import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'
import { queryEncoding } from '../../lib/common'

import * as Constants from './constants'
import * as brActions from './actions'
const getKhachHangState = state => state.khachhang;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_LIST_API,
    formData
  )

  return handleRequest(request);
}
function exportXlsRequestApi(formData) {
  const url = `${Constants.KHACHHANG_EXPORT_XLS_API}?${queryEncoding(formData)}`
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}

function listCmbRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_CMB_LIST_API,
    formData
  )

  return handleRequest(request);
}

function khachhangUserRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_USER_LIST_API,
    formData
  )

  return handleRequest(request);
}

function khachhangDvhcRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_DVHC_LIST_API,
    formData
  )
  return handleRequest(request);
}

function khachhangNhomRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_NHOM_LIST_API,
    formData
  )
  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function userDetailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_USER_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function khachhangUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function khachhangUserUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_USER_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function khachhangRemoveRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_REMOVE_API,
    formData
  )

  return handleRequest(request);
}

function khachhangUploadRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_UPLOAD_API,
    formData
  )

  return handleRequest(request);
}

function* khachhangListRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.khachhangListSuccess(results.data))

  } catch (error) {
    yield put(brActions.khachhangListError(error))
  }
}

function* khachhangExportXlsRequestFlow(action) {
  try {
    console.log("action", action)
    const { formData, callback } = action
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(brActions.khachhangExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(brActions.khachhangExportXlsError(error))
  }
}

function* khachhangCmbListRequestFlow() {
  const khachhang = yield select(getKhachHangState);
  try {
    // grab the client from our action
    const results = yield call(listCmbRequestApi, khachhang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.cmbListSuccess(results.data))

  } catch (error) {
    yield put(brActions.cmbListError(error))
  }
}

function* khachhangUserListRequestFlow() {
  const khachhang = yield select(getKhachHangState);
  try {
    // grab the client from our action
    const results = yield call(khachhangUserRequestApi, khachhang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.khachhangUserListSuccess(results.data))

  } catch (error) {
    yield put(brActions.khachhangUserListError(error))
  }
}
function* khachhangDvhcListRequestFlow() {
  const khachhang = yield select(getKhachHangState);
  try {
    // grab the client from our action
    const results = yield call(khachhangDvhcRequestApi, khachhang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.khachhangDvhcListSuccess(results.data))

  } catch (error) {
    yield put(brActions.khachhangDvhcListError(error))
  }
}
function* khachhangNhomListRequestFlow(action) {
  try {
    // grab the client from our action
    const results = yield call(khachhangNhomRequestApi, action.formData)

    // dispatch the action with our widgets!
    yield put(brActions.khachhangNhomListSuccess(results.data))

  } catch (error) {
    yield put(brActions.khachhangNhomListError(error))
  }
}
function* khachhangDetailRequestFlow() {
  const khachhang = yield select(getKhachHangState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, khachhang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.khachhangDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.khachhangDetailError(error))
  }
}

function* khachhangUserDetailRequestFlow() {
  const khachhang = yield select(getKhachHangState);
  try {
    // grab the client from our action
    const results = yield call(userDetailRequestApi, khachhang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.khachhangUserDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.khachhangUserDetailError(error))
  }
}

function* khachhangUpdateRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const response = yield call(khachhangUpdateRequestApi, payload)
    if (response.code != 200) {
      return yield put(brActions.khachhangUpdateError(response.message))
    }
    // dispatch the action with our widgets!
    yield put(brActions.khachhangUpdateSuccess(response));
  } catch (error) {
    yield put(brActions.khachhangUpdateError(error))
  }
}

function* khachhangUserUpdateRequestFlow(action) {
  const khachhang = yield select(getKhachHangState);
  try {
    // grab the client from our action
    const result = yield call(khachhangUserUpdateRequestApi, khachhang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.khachhangUserUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.khachhangUserUpdateError(error))
  }
}

function* khachhangUploadRequestFlow(action) {
  const khachhang = yield select(getKhachHangState);
  try {
    // grab the client from our action
    const result = yield call(khachhangUploadRequestApi, khachhang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.khachhangUploadSuccess(result));
  } catch (error) {
    yield put(brActions.khachhangUploadError(error))
  }
}

// update diem tich luy khach hang từ file
function* khachhangUploadPointsRequestFlow({ formData, onSuccess, onError }) {
  try {
    const request = axiosApi().post(
      Constants.KHACHHANG_UPDATE_DIEM_LIST_TL_API,
      formData
    )
    const response = yield call(handleRequest, request);
    // dispatch the action with our widgets!
    yield call(onSuccess, response)
  } catch (error) {
    yield call(onError, error)
  }
}

function* updateDiemTLFlow({ formData, onSuccess, onError }) {
  try {
    const request = axiosApi().post(
      Constants.KHACHHANG_UPDATE_DIEM_TL_API,
      formData
    )
    // grab the client from our action
    const { code, message } = yield call(handleRequest, request)

    if (code == 200) {
      return yield call(onSuccess, message)
    }
    yield call(onError, message)
  } catch (error) {
    yield call(onError, error)
  }
}

function* khachhangRemoveRequestFlow(action) {
  const khachhang = yield select(getKhachHangState);
  try {
    // grab the client from our action
    const result = yield call(khachhangRemoveRequestApi, khachhang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.khachhangRemoveSuccess(result));
  } catch (error) {
    yield put(brActions.khachhangRemoveError(error))
  }
}

function* khachhangTraThuongRequestFlow({ payload, callback }) {
  try {
    const request = axiosApi().post(
      Constants.KHACHHANG_TRATHUONG_API,
      payload
    )
    // grab the client from our action
    const response = yield call(handleRequest, request)
    if (response.code != 200) {
      return yield put(brActions.khachhangTraThuongError(response.message))
    }
    // dispatch the action with our widgets!
    yield put(brActions.khachhangTraThuongSuccess(response));
    if (typeof callback == 'function') {
      yield call(callback, response);
    }
  } catch (error) {
    yield put(brActions.khachhangTraThuongError(error))
  }
}

function* khachhangWatcher() {
  yield [
    takeLatest(Constants.KHACHHANG_LIST_REQUESTING, khachhangListRequestFlow),
    takeLatest(Constants.KHACHHANG_EXPORT_XLS_REQUESTING, khachhangExportXlsRequestFlow),
    takeLatest(Constants.KHACHHANG_DETAIL_REQUESTING, khachhangDetailRequestFlow),
    takeLatest(Constants.KHACHHANG_UPDATE_REQUESTING, khachhangUpdateRequestFlow),
    takeLatest(Constants.KHACHHANG_USER_UPDATE_REQUESTING, khachhangUserUpdateRequestFlow),
    takeLatest(Constants.KHACHHANG_CMB_LIST_REQUESTING, khachhangCmbListRequestFlow),
    takeLatest(Constants.KHACHHANG_USER_LIST_REQUESTING, khachhangUserListRequestFlow),
    takeLatest(Constants.KHACHHANG_USER_DETAIL_REQUESTING, khachhangUserDetailRequestFlow),
    takeLatest(Constants.KHACHHANG_UPLOAD_REQUESTING, khachhangUploadRequestFlow),
    takeLatest(Constants.KHACHHANG_UPDATE_DIEM_TLS_REQUESTING, khachhangUploadPointsRequestFlow),
    takeLatest(Constants.KHACHHANG_DVHC_LIST_REQUESTING, khachhangDvhcListRequestFlow),
    takeLatest(Constants.KHACHHANG_REMOVE_REQUESTING, khachhangRemoveRequestFlow),
    takeLatest(Constants.KHACHHANG_UPDATE_DIEM_TL_REQUESTING, updateDiemTLFlow),
    takeLatest(Constants.KHACHHANG_NHOM_LIST_REQUESTING, khachhangNhomListRequestFlow),
    takeLatest(Constants.KHACHHANG_TRATHUONG_REQUESTING, khachhangTraThuongRequestFlow)
  ]
}

export default khachhangWatcher



// WEBPACK FOOTER //
// ./src/views/KhachHang/sagas.js